import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Button, { ButtonProps } from '@material-ui/core/Button';
import cx from 'clsx';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  container: {
    display: 'inline-block',
    height: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(0.75)
  }
}));

const FilterBarButtonInput: React.FC<ButtonProps & {
  containerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  marginDense?: boolean;
}> = ({
  children,
  marginDense,
  className,
  size = 'small',
  containerProps: { className: containerClassName, ...restContainer } = {},
  ...rest
}) => {
  const classes = useStyles();
  return (
    <div className={cx(classes.container, containerClassName)} {...restContainer}>
      <Button
        variant="text"
        size={size}
        disableElevation
        className={cx(classes.button, { [classes.marginVertical]: !marginDense }, className)}
        {...rest}
      >
        {children}
      </Button>
    </div>
  );
};

export default FilterBarButtonInput;
